import React from "react";
import classes from "./ModalInfo.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const SubscribeModal = ({ setModal }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className={classes.container} onClick={() => setModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <div className={classes.info}>
                    <img
                        src="/assets/images/info.png"
                        alt="info"
                        className={classes.img}
                    />
                </div>
                <div className={classes.msg}>
                    <p className={classes.text}>{t("96")}</p>
                    <p className={classes.text}>{t("97")}</p>
                </div>
                <div className={classes.btns_container}>
                    <button className={classes.btn} type="button" onClick={() => navigate("/subscribe")}>
                        {t("80")}
                    </button>
                    <button
                        className={classes.btn_2}
                        type="button"
                        onClick={() => setModal(false)}
                    >
                        {t("81")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SubscribeModal;